<script>
    import {createEventDispatcher} from 'svelte/internal';
    import Icon from "../components/Icon.svelte";
    import SortIcon from "./icons/SortIcon.svelte";

    export let tableColumns = [];

    const dispatch = createEventDispatcher();

    const onColumnClick = (column) => {
        if (column.sortable) {
            tableColumns.map(item => {
                if (item.key !== column.key && column.sortable) {
                    item.sort_way = null;
                }
            });
            column.sort_way = column.sort_way === 'ASC' ? 'DESC' : 'ASC';
            tableColumns = tableColumns;
            dispatch('sort', column);
        }
    };
</script>

<thead>
<tr>
    {#each tableColumns as column}
        {#if !column.hidden}
            <th class="{ column.class || '' }">
                <div class="content">
                    <div class="title" class:sortable={ column.sortable } on:click={ () => onColumnClick(column) }>
                        { column.title }
                    </div>
                    {#if column.sortable}
                        <div class="sort">
                            <SortIcon sort="{ column.sort_way }"/>
                        </div>
                    {/if}
                </div>
            </th>
        {/if}
    {/each}
</tr>
</thead>

<style>
    thead th {

    }

    thead th .content {
        display: flex;
        align-items: center;
    }

    thead th .title {
        font-size: .8rem;
        font-weight: normal;
        letter-spacing: 1px;
        color: #999;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    thead th .title.sortable {
        max-width: calc(100% - 15px);
        cursor: pointer;
    }

    thead th .title.sortable:hover {
        color: #666;
    }

    thead th .sort {
        /*padding-left: 5px;*/
        width: 15px;
    }
</style>